import { fileStateQueryFunctions } from '@/common/queries/selections/fileStates/fileStateQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

export const fileStateDefaultQueryOption = () => {
  return queryOptions({
    queryFn: fileStateQueryFunctions,
    queryKey: ['file-state'],
    select: (data) => {
      return data.map((item) => ({
        label: item.fa_name,
        value: item.name,
        count: item.count,
      }));
    },
  });
};
